<template>
    <v-container fill-height fluid>
        <v-row align="center"
            justify="center">
            <v-col>
                <streamBarcodeReader style="height:255px"
                    @decode="onDecode"
                ></streamBarcodeReader>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { StreamBarcodeReader } from "vue-barcode-reader";

export default {
    methods: {           
        onDecode (decodedString) {
            console.log(decodedString)
        }
    },

    components: {
        "streamBarcodeReader": StreamBarcodeReader
    },

    /*created(){
        let loginData = JSON.parse(localStorage.getItem("loginData"));
      
        let canOrder = loginData.permissionAndMenu.find(permission => {
          return permission.menuId == 216
        });

        if(canOrder == null)
            this.$router.push('menu');
    }*/
}
</script>